import React, {  useContext } from "react";

// import context provider from APP.JSX to get the state
import {ContextProvider} from "../../App"

// import modules
import Home from "./Home.jsx";
import Services from "./Services.jsx";
import Footer from "../../common/Footer.jsx";

function HomeIndex() {

  const {modalsState, modalsDispatch, isMobile, isTablet, authState} = useContext(ContextProvider)
  
  return (
    <>
      <Home signUp={modalsState.signUp} signIn={modalsState.signIn} authState={ authState } modalsDispatch={modalsDispatch}/>
      <Services />
      <Footer footerWidth={isMobile || isTablet ? "100%" : "60%"}/>
    </>
  );
}

export default HomeIndex;
